import { getRandomFromList } from '../../utils/data/random/getRandomFromRange';
import gsap from 'gsap';

export default class PuzzleController {
  rowClass = 'puzzle__row';
  columnClass = 'puzzle__column';
  columnBlockClass = 'puzzle__column-block';
  imageClass = 'puzzle__image-item';
  clickItemClass = 'puzzle__click-item';

  hitArea = {
    width: 90,
    height: 90,
  };

  constructor({ container, settings, onComplete, image }) {
    this.onResize = this.onResize.bind(this);

    this.container = container;
    this.settings = settings;

    const { rows, columns, angle } = settings;

    const angleOptions = arrayRange(angle.min, angle.max, angle.delta);

    const items = [];

    for (let i = 0; i < columns; i++) {
      const iDiv = document.createElement('div');
      iDiv.classList.add(this.rowClass);
      iDiv.classList.add(this.rowClass + '_' + (i + 1));

      iDiv.style.position = `relative`;
      iDiv.style.transform = `translateZ(0)`; //for safari

      for (let j = 0; j < rows; j++) {
        const jDiv = document.createElement('div');
        const jDivBlock = document.createElement('div');
        jDiv.classList.add(this.columnClass);
        jDivBlock.classList.add(this.columnBlockClass);
        jDiv.appendChild(jDivBlock);
        jDivBlock.style.overflow = `hidden`;
        jDiv.style.position = `relative`;
        jDiv.id = `${i}-${j}`;

        const clickArea = document.createElement('div');
        clickArea.classList.add(this.clickItemClass);
        clickArea.style.height = `${this.hitArea.height}%`;
        clickArea.style.width = `${this.hitArea.width}%`;
        clickArea.style.position = 'absolute';
        clickArea.style.top = `${(100 - this.hitArea.height) / 2}%`;
        clickArea.style.left = `${(100 - this.hitArea.width) / 2}%`;

        const img = this.createImage({ image });

        jDivBlock.appendChild(img);
        jDiv.appendChild(clickArea);

        iDiv.appendChild(jDiv);

        gsap.set(jDiv, { rotation: getRandomFromList(angleOptions) });

        const eventTarget = clickArea;

        const currentData = { eventTarget, rotationTarget: jDiv, iDiv, imgData: { img, i, j } };

        items.push(currentData);

        currentData.__handler = this.onClick.bind(this, { ...currentData, items, onComplete, angle });

        eventTarget.addEventListener('click', currentData.__handler);
      }
      container.appendChild(iDiv);
    }

    this.items = items;

    this.onResize();

    window.addEventListener('resize', this.onResize);
  }

  createImage({ image }) {
    const img = document.createElement('img');

    img.src = image;
    img.classList.add(this.imageClass);
    img.style.pointerEvents = 'none';
    img.style.position = 'absolute';

    return img;
  }

  onClick = ({ rotationTarget: target, items, onComplete, angle }, event) => {
    if (gsap.isTweening(target)) return;

    target.__nextAngle = gsap.getProperty(target, 'rotation') + angle.delta;

    const cardTimeline = gsap.timeline({
      onComplete: () => this.checkEnd(items, onComplete),
    });

    cardTimeline
      .to(target, { duration: 0.15, ease: 'sine.inOut', scale: 0.75 })
      .to(target, { duration: 0.35, ease: 'sine.inOut', rotation: target.__nextAngle })
      .to(target, { duration: 0.15, ease: 'sine.inOut', scale: 1 });

    event.preventDefault();
  };

  checkEnd(items, onComplete) {
    // NOTE: иногда стреляет ошибка в кибану, что this.settings.angle = null
    if (!this.settings || !this.settings.angle) return;

    const {
      settings: {
        angle: { targetAngle },
      },
    } = this;

    const isEnd = items.every((item) => {
      const angle = gsap.getProperty(item.rotationTarget, 'rotation');
      return Math.abs(angle % targetAngle) < 0.001;
    });

    if (isEnd) {
      this.onComplete(items);
      onComplete?.();
    }
  }

  onComplete(items) {
    items.forEach((item) => {
      item.eventTarget.removeEventListener('click', item.__handler);
    });
  }

  destroy() {
    const { items } = this;
    items.forEach((item) => item.eventTarget.removeEventListener('click', item.__handler));
    this.container = null;
    this.items = null;
    this.settings = null;
    this.onComplete = null;
    this.hitArea = null;
    this.image = null;
    this.angle = null;
    this.rowClass = null;
    this.columnClass = null;
    this.columnBlockClass = null;
    this.clickItemClass = null;
    this.imageClass = null;
  }

  onResize() {
    const { container, settings, items } = this;

    if (!container || !settings || !items) return;

    const { clientWidth, clientHeight } = container;

    const { rows, columns, gap } = settings;

    const offsetX = clientWidth / columns - gap / Math.max(1, columns - 1);
    const offsetY = clientHeight / rows - gap / Math.max(1, rows - 1);

    items.forEach(({ iDiv, rotationTarget: jDiv, imgData: { i, j, img } }) => {
      iDiv.style.width = `100%`;
      iDiv.style.height = `${offsetY}px`;

      jDiv.style.height = iDiv.style.height;
      jDiv.style.width = `${offsetX}px`;

      img.style.top = `-${i * offsetY}px`;
      img.style.left = `-${j * offsetX}px`;
    });
  }
}

function arrayRange(start, stop, step) {
  return Array.from({ length: (stop - start) / step + 1 }, (value, index) => start + index * step);
}
